import { renderTemplate, SB } from '@play-co/replicant';

/**
 * Assets for wallpaper messages
 */
export const wallpaperAssets = {
  // Wallpaper challenge: Kingkong
  'wallpaper/kingkong/1080': 'private/chatbot/wallpaper/kingkong_1080x1920.png',
  'wallpaper/kingkong/1080/preview':
    'private/chatbot/wallpaper/kingkong_1080x1920_preview.png',
  'wallpaper/kingkong/1170': 'private/chatbot/wallpaper/kingkong_1170x2532.png',
  'wallpaper/kingkong/1170/preview':
    'private/chatbot/wallpaper/kingkong_1170x2532_preview.png',

  // Free gems compensation
  'wallpaper/migration/1170/preview':
    'private/chatbot/wallpaper/migration_1170x2532_preview.png',
  'wallpaper/migration/1170':
    'private/chatbot/wallpaper/migration_1170x2532.png',

  // Special compensation
  'wallpaper/candyland/1170/preview':
    'private/chatbot/wallpaper/candyland_1170x2532_preview.png',
  'wallpaper/candyland/1170':
    'private/chatbot/wallpaper/candyland_1170x2532.png',
};

// Generic wallpaper template
export function wallpaperTemplate(
  id: 'migration' | 'candyland' | 'kingkong',
  size: '1170' | '1080',
) {
  return renderTemplate({
    args: SB.object({}),
    renderers: {
      line: ({ api }) => {
        return {
          type: 'image',
          originalContentUrl: api.getAssetPath(`wallpaper/${id}/${size}`),
          previewImageUrl: api.getAssetPath(`wallpaper/${id}/${size}/preview`),
        };
      },
    },
  });
}
